module.exports = __webpack_public_path__ + "static/media/icon_estado_pendiente.88f63289.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_estado_pendiente.svg
// module id = 329
// module chunks = 0